interface ErrorDialogProps {
  title: string;
  message: string;
  onOk: () => void;
}

export const ErrorDialog: React.FC<ErrorDialogProps> = ({
  title,
  message,
  onOk,
}) => {
  //エラーポップアップを閉じる処理(親コンポーネントに任せる)
  const handleClose = () => {
    onOk();
  };
  console.log("message:", message);
  console.log("title: ", title);
  return (
    <>
      {/* エラーポップアップ表示 */}
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
        <div className="bg-white w-3/4">
          <div className="flex justify-center items-center">
            <h2 className="text-lg font-bold mt-3">{title}</h2>
          </div>
          <div className="flex justify-center items-center">
            <p className="mt-5 text-gray-700 whitespace-nowrap">{message}</p>
          </div>
          <div className="flex justify-center items-center border-t border-black mt-5">
            <button
              onClick={() => handleClose()}
              className="py-2 w-full h-full text-sub-blue"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
